import api from "@/api/api";
import * as Helpers from "@/helpers";

export default {
  async Search(store, params) {
    store.dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("drp/produto/" + params.idproduto, {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        store.dispatch("loadingAux/habilitarLoading", false, { root: true });
        return resp.data.item
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false, { root: true });
        // Helpers.logout();
      });
  },
  async Store(store, params) {
    store.dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "post",
      url: "drp/produto",
      headers,
      data: params
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        store.dispatch("loadingAux/habilitarLoading", false, { root: true });
        return true;
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false, { root: true });
        // Helpers.logout();
      });
  },
  async Delete(store, params) {
    store.dispatch("loadingAux/habilitarLoading", true, { root: true });
    const headers = Helpers.iniciarRequisicao();
    return await api
      .delete("drp/produto/" + params.id, {
        headers,
        params
      })
      .then(resp => {
        store.dispatch("loadingAux/habilitarLoading", false, { root: true });
        localStorage.setItem("token", resp.data.token);
      })
      .catch(() => {
        store.dispatch("loadingAux/habilitarLoading", false, { root: true });
        // Helpers.logout();
      });
  },
};
